const initialState = { indices: {} };

const personalizedIndex = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_PERSONALIZED_INDEX':
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default personalizedIndex;
